import { Box, Text } from "@chakra-ui/react";
import { crm } from "../../../theme";

const StatusPickerPopover = ({
  position,
  statuses,
  onPick,
  onClose,
}: {
  position: { x: number; y: number };
  statuses: string[];
  onPick: (status: string) => void;
  onClose: () => void;
}) => (
  <>
    <Box position="fixed" inset={0} zIndex={1000} onClick={onClose} />
    <Box
      position="fixed"
      left={Math.min(position.x, window.innerWidth - 240)}
      top={Math.min(position.y, window.innerHeight - 40 - statuses.length * 34)}
      zIndex={1001}
      bg={crm.surface}
      boxShadow={crm.shadowLg}
      borderRadius="10px"
      border={`1px solid ${crm.border}`}
      py="6px"
      minW="220px"
      maxH="260px"
      overflowY="auto"
    >
      <Text fontSize="xs" color={crm.textMuted} px="12px" py="4px" fontWeight="600">
        Escolha o status
      </Text>
      {statuses.map((s) => (
        <Box
          key={s}
          px="12px"
          py="8px"
          fontSize="sm"
          color={crm.text}
          cursor="pointer"
          _hover={{ bg: crm.brandSoft, color: crm.brand }}
          onClick={() => onPick(s)}
        >
          {s}
        </Box>
      ))}
    </Box>
  </>
);

export default StatusPickerPopover;
